/*
  Slider
-------------------------------*/
jQuery(document).ready(function($) {
    "use strict";
    $('.lesh_s6_slider__carousel').slick({
        slidesToShow: 2,
        slidesToScroll: 1,
        dots: false,
        focusOnSelect: true,
        arrows: true,
        prevArrow: '<button class="slick-prev slick-arrow"></button>',
        nextArrow: '<button class="slick-next slick-arrow"></button>',
        responsive: [{
            breakpoint: 1199,
            settings: {
                slidesToShow: 1,
            }
        }, ]
    });
    $('.lesh_s3_slider').slick({
        dots: false,
        adaptiveHeight: false,
        autoplay: false,
        autoplaySpeed: 5000,
        slidesToShow: 3,
        arrows: true,
        responsive: [{
                breakpoint: 1025,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 769,
                settings: {
                    slidesToShow: 1,
                }
            },
            {
                breakpoint: 550,
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
    });
});

jQuery(document).ready(function($) {
    "use strict";

    $('.lesh_s6_slider').slick({
        dots: false,
        adaptiveHeight: true,
        autoplay: false,
        autoplaySpeed: 5000,
        slidesToShow: 3,
        arrows: true,
        responsive: [{
                breakpoint: 1025,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 769,
                settings: {
                    slidesToShow: 1,
                }
            },
            {
                breakpoint: 550,
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
    });
});

jQuery(document).ready(function($) {
    "use strict";
    $('.lesh_s5_slider').slick({
        dots: false,
        adaptiveHeight: false,
        autoplay: false,
        autoplaySpeed: 5000,
        slidesToShow: 1,
        arrows: true
    });
    $('.reviews-video-slide-wrapper').slick({
        dots: false,
        adaptiveHeight: false,
        autoplay: false,
        autoplaySpeed: 5000,
        slidesToShow: 1,
        arrows: true
    });
});


/////////////////////////////////////////////////////
// instagramFeed //
/////////////////////////////////////////////////////
$(window).on('load', function() {
    var instagram_feed_username = $('#instagram_feed').attr('data-ig-name');
    $.instagramFeed({
        'username': instagram_feed_username,
        'container': "#instagram_feed",
        'display_profile': false,
        'display_biography': true,
        'display_igtv': false,
        'items': 6,
        'items_per_row': 6,
        'margin': 0
    });
});


/*
  Responsive Menu
------------------------------------------------------------------------*/
jQuery(document).ready(function($) {
    "use strict";

    var ph1_responsive_menu = $(".responsive-menu");


    $('body').on("click", 'a.responsive-menu-hand', function() {
        $($(this).attr('href')).clone().appendTo(ph1_responsive_menu);


        if ($(".responsive-menu").hasClass('active')) {
            $(".responsive-menu").slideUp();
            $(".responsive-menu").removeClass('active');
            $(".responsive-menu ul").remove();
            $("body").removeClass('mobile-menu-active');
        } else {
            $(".responsive-menu").slideDown();
            $(".responsive-menu").addClass('active');
            $("body").addClass('mobile-menu-active');
        }
        return false;
    });

    $('body').on("click", 'a.responsive-menu-close', function() {
        $(".responsive-menu").slideUp();
        $(".responsive-menu").removeClass('active');
        $(".responsive-menu ul").remove();
        $("body").removeClass('mobile-menu-active');
    });

    $('body').on("click", '.responsive-menu ul li.has_child:has(ul) > a', function(e) {
        if ($(this).next().hasClass('active')) {
            $(this).next().removeClass('active');
            e.preventDefault();
        } else {

            $(this).next('ul').slideToggle();

        }
        return false;
    });
});


jQuery(document).ready(function($) {
    "use strict";
    $(".site-header").clone().appendTo(".fixed-header");
});

jQuery(window).scroll(function() {
    "use strict";

    var sa_body_scroll = jQuery(document).scrollTop();

    if (sa_body_scroll > 50) {
        jQuery('.pf4_site_header').addClass('active');
        jQuery('.fixed-header').addClass('active');
    } else if (sa_body_scroll < 250) {
        jQuery('.pf4_site_header').removeClass('active');
        jQuery('.fixed-header').removeClass('active');
    }
});



// Collection Slider
jQuery(document).ready(function(){
   $('.collection-slider').slick({
    infinite: true,
    slidesToShow: 1,
    arrows: true,
    dots: false,
    slidesToScroll: 1,
      autoplay: true,
  autoplaySpeed: 2000
  });
  });

// Quantity selecotr
$('.qtybox .btnqty').on('click', function(){
  var value = parseInt($(this).parent('.qtybox').find('.quantity-input').val());
  var qty = parseInt(value);
  if($(this).hasClass('qtyplus')) {
    qty++;
  }else {
    if(qty > 1) {
      qty--;
    }
  }
  qty = (isNaN(qty))?1:qty;
  $(this).parent('.qtybox').find('.quantity-input').val(qty);
}); 




